import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";
import { renderRichText, applyLocaleToUrl } from "@/utils/formatters";
import { useRouter } from "next/router";

const SimpleContent = ({ simpleContentData = {} }) => {
  const { locale } = useRouter();
  const {
    title,
    subTitle,
    upperDescription,
    lowerDescription,
    image,
    textAlign = "",
    ctas = [],
    backgroundColor = "white",
    useFontSize = false,
    description = "",
    fontSize,
    showBorder,
    titleFontSize,
  } = simpleContentData;
  return (
    <div className={styles.wrapper}>
      <section
        className={`c-koh-simple-content v-koh-full-page koh-title-desc-comp ${backgroundColor}-bg`}
      >
        <div className="koh-simple-content-container">
          <div className="koh-simple-content-body">
            {image && (
              <p className="flex justify-center">
                <img
                  src={
                    image?.fields?.imageUrl ??
                    `${image.fields?.asset?.fields?.file?.url}`
                  }
                  alt={image?.fields?.alt}
                />
              </p>
            )}
            {title && (
              <h1 className={`title-text-center md:text-[${titleFontSize}px]`}>
                {title}
              </h1>
            )}
            {subTitle && (
              <h3
                className={`title-text-center sub-title ${useFontSize && "change-font-subtitle"}`}
              >
                {subTitle}
              </h3>
            )}
            {upperDescription && (
              <p
                className={`desc-text-center ${textAlign}-aligned`}
                style={{ fontSize: fontSize ? `${fontSize}px` : "14px" }}
              >
                {upperDescription}
              </p>
            )}
            {description && (
              <div className={`desc-text-center ${textAlign}-aligned`}>
                {renderRichText(description, locale)}
              </div>
            )}
            {lowerDescription && (
              <p
                className={`desc-text-center ${textAlign}-aligned`}
                style={{ wordSpacing: "-1.0px" }}
              >
                {lowerDescription}
              </p>
            )}
          </div>
          {ctas?.map(({ fields: { label, url, mediaUrl } = {} } = {}) => (
            <div
              key={label}
              className="cta-container py-[10px] px-[8px] box-border pointer-events-auto text-[10px] text-[#232323] leading-[1.428571429] font-helvetica"
            >
              <a
                className="cta-link border-0 rounded-[4px] py-[10px] px-[20px] no-underline text-[1.3em] text-center relative left-1/2 -translate-x-1/2 inline-block uppercase outline-none shadow-[0_2px_2px_rgba(0,0,0,0.2)] box-border !font-[HelveticaBold,Helvetica,sans-serif]"
                href={applyLocaleToUrl(url || mediaUrl, locale)}
              >
                {label}
              </a>
            </div>
          ))}
        </div>
        {showBorder && (
          <div className="border-b border-black mb-4 mt-[25px]"></div>
        )}
      </section>
    </div>
  );
};

SimpleContent.propTypes = {
  simpleContentData: PropTypes.shape({
    title: PropTypes.string,
    description1: PropTypes.string,
    description2: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
    textAlign: PropTypes.string,
    ctas: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
      })
    ),
    backgroundColor: PropTypes.string,
    fontSize: PropTypes.string,
  }),
};

export default SimpleContent;
